import { platformApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteBrief() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => {
      if (code) {
        return platformApi.delete(`briefs/${code}`).json();
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['briefs'] }),
  });
}
